export enum CategoryDisplayNameType
{
    FullName = 1,
    ShortName = 2,
    Tag = 3
}